<template>
  <v-dialog v-model="isOpenActionEditor" width="400" max-width="100vw" persistent>
    <v-card>
      <v-card-title class="headline pa-4">
        {{ title }}
      </v-card-title>
      <v-divider />
      <v-card-text  class="pa-4 overflow-y-auto" style="max-height: calc(100vh - 210px);">
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="payload.name"
              v-validate="'required'"
              :label="$t('actionsModel.fields.name')"
              :data-vv-name="$t('actionsModel.fields.name')"
              :error-messages="[...errors.collect($t('actionsModel.fields.name')), ...(errorMessages.name || [])]"
              :readonly="loading || ['detail'].includes(actionEditorMode)"
              @input="errorMessages.name = []"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="payload.description"
              v-validate="'max:250'"
              :label="$t('actionsModel.fields.description')"
              :data-vv-name="$t('actionsModel.fields.description')"
              :error-messages="[...errors.collect($t('actionsModel.fields.description')), ...(errorMessages.description || [])]"
              :readonly="loading || ['detail'].includes(actionEditorMode)"
              counter="250"
              no-resize
              rows="3"
              @input="errorMessages.description = []"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          @click="close()"
          :disabled="loading"
          color="primary"
          text
          width="120"
        >
          {{ $t('actions.cancel') }}
        </v-btn>
        <v-btn
          v-if="['detail'].includes(actionEditorMode)"
          @click="setActionEditorMode('edit')"
          :loading="loading"
          color="primary"
          width="120"
        >
          {{ $t('actions.edit') }}
        </v-btn>
        <v-btn
          v-else
          @click="submit()"
          :loading="loading"
          color="primary"
          width="120"
        >
          {{ $t('actions.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ActionEditor',
  data: () => ({
    loading: false,
    errorMessages: {},
    payload: {
      id: null,
      name: '',
      description: ''
    }
  }),
  computed: {
    ...mapGetters({
      isOpenActionEditor: 'actions/isOpenActionEditor',
      actionEditorMode: 'actions/actionEditorMode',
      action: 'actions/action'
    }),
    title () {
      if (this.actionEditorMode === 'create') {
        return 'Crear acción'
      }
      if (this.actionEditorMode === 'detail') {
        return 'Detalle de acción'
      }
      return 'Editar acción'
    }
  },
  watch: {
    action (newVal) {
      if (newVal.id) {
        this.setPayload(newVal)
      }
    }
  },
  methods: {
    ...mapActions({
      saveAction: 'actions/saveAction',
      updateAction: 'actions/updateAction'
    }),
    ...mapMutations({
      toggleActionEditor: 'actions/toggleActionEditor',
      setAction: 'actions/setAction',
      setActionEditorMode: 'actions/setActionEditorMode'
    }),
    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }
      const {
        payload,
        actionEditorMode,
        saveAction,
        updateAction
      } = this
      this.loading = true
      let result
      if (['create'].includes(actionEditorMode)) {
        result = await saveAction(payload)
      } else {
        result = await updateAction(payload)
      }
      this.loading = false
      if (result.success) {
        this.close()
      } else {
        this.setErrorMessages(result.errors)
      }
    },
    setErrorMessages (errors) {
      errors.forEach(({ field, message, validation }) => {
        if (!this.errorMessages[field]) {
          this.errorMessages[field] = []
        }
        this.errorMessages[field].push(this.$t(`messages.validation_error.${validation}`, null, { field: this.$t(`actionsModel.fields.${field}`) }))
      })
    },
    setPayload (payload) {
      this.payload = payload
    },
    setDefaultData () {
      this.loading = false
      this.errorMessages = {}
      this.payload = {
        id: null,
        name: '',
        description: ''
      }
    },
    cleanData () {
      this.setDefaultData()
      this.setAction()
      this.$validator.reset()
    },
    close () {
      this.toggleActionEditor()
      this.cleanData()
    }
  }
}
</script>
